module.exports = __webpack_public_path__ + "static/media/angry-face-svgrepo-com.539410eb.svg";